export default __webpack_public_path__ + "static/media/dex-right-open.7285ab2c.png";